module.exports = __webpack_public_path__ + "static/media/10.26c6779a.JPG";